$('[data-js="expand-future-lessons"]').on('click', function() {
  $(this).closest('[data-js="period-divider-row"]').toggleClass('lessons-table__period-divider--expanded');
});
